// extracted by mini-css-extract-plugin
module.exports = {"menuListContainer":"az_Kdb","link":"az_Ldb"};